import { useI18n } from "i18n";
import { selectThemeAndTemplate } from "modules/theater/selectors";
import { getMapImageWithTheme } from "modules/theater/theater.helper";
import { useSelector } from "react-redux";
import { getMapTemplateByType } from "modules/event/template";
import { IMapTemplate } from "types/theater";
import { addDialogNotification } from "modules/dialogNotification/redux/dialogNotificationSlice";
import { useAppDispatch } from "store/hooks";
import logger from "../../../logging/logger";

interface IBackgroundSVGProps {
  spaceConfig: IMapTemplate;
  onLoad: () => void;
}
const BackgroundSVG = (props: IBackgroundSVGProps) => {
  const { spaceConfig, onLoad } = props;
  const { theme, template } = useSelector(selectThemeAndTemplate);
  const dispatch = useAppDispatch();
  const { t } = useI18n(["common", "template"]);
  const evTemplate = getMapTemplateByType(template);

  if (!spaceConfig || !spaceConfig.image || !evTemplate) {
    return null;
  }

  const image = getMapImageWithTheme(evTemplate, theme);

  const getDialogContent = () => (
    <div>
      <p>{t("template:image.blocked.network.text")}</p>
      <p>
        {t("template:open.message")}
        <a href={image} rel="noopener noreferrer" target="_blank">
          {image}
        </a>{" "}
        {t("template:new.tab")}{" "}
      </p>
      <p>{t("template:blocked.by.firewall")}</p>
    </div>
  );

  const onMaploadError = () => {
    logger.error(`[BackgroundSVG] map ${image} not loaded.`);
    dispatch(
      addDialogNotification({
        content: getDialogContent(),
        hideCloseButton: true,
        title: "Please check your firewall settings",
        hideDismissButton: true,
        confirmText: t("button.ok"),
      }),
    );
  };

  return (
    <div className="re-svg">
      <img
        alt="background"
        onLoad={onLoad}
        onError={onMaploadError}
        src={image}
        width={spaceConfig.width}
        height={spaceConfig.height}
      />
    </div>
  );
};

export default BackgroundSVG;
